import http from "./http-common";
import Crypto from "./Crypto"
import { getServidor } from "../utils/Utils";

/**
 * @class ModelosDataService
 * @brief Gestiona las operaciones de acceso a los datos de modelos.
 */

class ModelosDataService {

    /**
     * @brief Obtiene el listado de todos los modelos registrados.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición con los modelos registrados.
     */
    getAll() {
        return http.get(`${getServidor()}/modelo/`);
    }
    /**
     * @brief Obtiene el listado de todos los modelos habilitados.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición con los modelos habilitados.
     */
    getAllHabilitados() {
        return http.get(`${getServidor()}/modelo/habilitados`);
    }
    /**
     * @brief Registra un nuevo modelo en el sistema.
     *
     * @param data Datos del modelo a registrar.
     * @param key Clave utilizada para encriptar los datos antes de enviarlos.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición con el modelo registrado.
     */
    async create(data, key) {
        const datosEncriptados = await Crypto.encriptar(data, key);
        return http.post(`${getServidor()}/modelo/`, datosEncriptados);
    }
    /**
     * @brief Actualiza los datos de un modelo en el sistema.
     *
     * @param data Datos actualizados del modelo.
     * @param key Clave utilizada para encriptar los datos antes de enviarlos.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición con el modelo actualizado.
     */
    async update(data, key) {
        const datosEncriptados = await Crypto.encriptar(data, key);
        return http.put(`${getServidor()}/modelo/`, datosEncriptados)
    }
    /**
     * @brief Habilita o deshabilita un modelo de GPS en el sistema.
     *
     * @param key Clave utilizada para encriptar el identificador del modelo antes de enviarlo.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la petición con el modelo eliminado.
     */
    async delete(key) {
        const datosEncriptados = await Crypto.encriptar(sessionStorage.idModelo, key);
        return http.delete(`${getServidor()}/modelo/`, { data: datosEncriptados });
    }
}
/**
 * Variable para exportar
 */
export default new ModelosDataService();